import { t } from 'utils/i18n';
// what the New task dialog sends: a task with the drawings, then the photos as a reference linked to it

export interface NewTaskInput {
    projectId: number;
    name: string;
    drawings: File[];
    photos: File[];
}

export function isDrawing(file: { type: string; name: string }): boolean {
    return file.type === 'application/pdf' || /\.pdf$/i.test(file.name) || file.type.startsWith('image/');
}

export function isPhoto(file: { type: string }): boolean {
    return file.type.startsWith('image/');
}

export function validate(input: NewTaskInput): string | null {
    if (!input.name.trim()) return t('Give the task a name');
    if (!input.drawings.length) return t('Add at least one drawing');
    return null;
}

// the same shape the create pages build, with the project's labels and default processing settings
function payload(projectId: number, name: string, files: File[]): Record<string, unknown> {
    return {
        projectId,
        basic: { name: name.trim() },
        subset: '',
        labels: [],
        advanced: { useZipChunks: true, useCache: true, sortingMethod: 'lexicographical' },
        files: {
            local: files, share: [], remote: [], cloudStorage: [],
        },
    };
}

export function taskPayload(input: NewTaskInput): Record<string, unknown> {
    return payload(input.projectId, input.name, input.drawings);
}

export function referencePayload(input: NewTaskInput, taskId: number): Record<string, unknown> | null {
    if (!input.photos.length) return null;
    return { ...payload(input.projectId, input.name, input.photos), taskId: [taskId] };
}
